import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
import _imports_0 from '../../../assets/img/box.png';
const _hoisted_1 = {
  class: "list-scroll-wrap",
  style: {
    "overflow": "auto"
  },
  ref: "listRef"
};
const _hoisted_2 = ["infinite-scroll-disabled"];
const _hoisted_3 = {
  key: 0,
  class: "no-more"
};
const _hoisted_4 = {
  key: 1,
  class: "no-data"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_driver_list = _resolveComponent("driver-list");
  const _component_mine_list = _resolveComponent("mine-list");
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: "scroll-list",
    "infinite-scroll-disabled": $data.disabled,
    "infinite-scroll-immediate": false,
    "infinite-scroll-distance": 10
  }, [$data.scrollList.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.type !== 'mine' ? (_openBlock(), _createBlock(_component_driver_list, {
    key: 0,
    list: $data.scrollList
  }, null, 8, ["list"])) : _createCommentVNode("", true), $props.type === 'mine' ? (_openBlock(), _createBlock(_component_mine_list, {
    key: 1,
    list: $data.scrollList
  }, null, 8, ["list"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 8, _hoisted_2)), [[_directive_infinite_scroll, $options.handleLoadMore]]), $data.noMore ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('message.NoMore')), 1)) : _createCommentVNode("", true), $data.noData && !$options.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.NoTemplate')), 1)])) : _createCommentVNode("", true)], 512);
}